import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {map, catchError} from 'rxjs/operators';

@Injectable()
export class InternalPackagingLabelService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getInternalPackagingLabel(gridData = new HttpParams(), params = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/internal-packaging-label/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getInternalPackagingLabelPdf(path, filename) {
    return this.http.get(environment.apiUrl + '/download?path=' + path + '&filename=' + filename, {
      responseType: 'arraybuffer' as 'json',
      observe: 'response'
    }).pipe(
      map((resp: HttpResponse<ArrayBuffer>) => this.helper.fileDownloadMap(resp)),
      catchError(res => this.helper.catchError(res))
    );
  }

  public generateProductionForms() {
    return this.http.get(environment.apiUrl + '/backoffice/production-form/generate', {
      responseType: 'arraybuffer' as 'json',
      observe: 'response'
    }).pipe(
      map((resp: HttpResponse<ArrayBuffer>) => this.helper.fileDownloadMap(resp)),
      catchError(res => this.helper.catchError(res))
    );
  }

  public generateSingleProductionForms(id) {
    return this.http.get(environment.apiUrl + '/backoffice/production-form/generate/' + id, {
      responseType: 'arraybuffer' as 'json',
      observe: 'response'
    }).pipe(
      map((resp: HttpResponse<ArrayBuffer>) => this.helper.fileDownloadMap(resp)),
      catchError(res => this.helper.catchError(res))
    );
  }
}
